<template>
    <el-form @submit.native.prevent label-width="100px" :inline="true" size="mini" ref="SEARCH" :model="getRequestData" class="demo-form-inline" :inline-message="false" :show-message="false">
        <template v-for="(formOneValue, formOneKey) in searchList">
            <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1&&ruleFlag ?[{required: true, trigger: ['blur', 'change']}] : []">
                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                <template v-if="flag(formOneValue)">
                    <slot name="searchInput" :formOneValue="formOneValue"></slot>
                </template>
                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item" :disabled="getRequestData[formOneValue.entityField] == null || getRequestData[formOneValue.entityField] == '' ? true : false"
                            effect="dark" :content="getRequestData[formOneValue.entityField]" placement="bottom-start">
                    <el-input class="form_codition" @clear="clear(formOneValue.setField)" clearable v-model="getRequestData[formOneValue.entityField]"
                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)">
                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-tooltip>
                <el-date-picker class="form_codition" v-else-if="formOneValue.fieldType == 'date1'" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
                                type="date" placeholder="选择日期">
                </el-date-picker>
                <el-date-picker @clear="timeClear('start')" class="form_codition" v-else-if="formOneValue.entityField == 'start'" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
                                value-format="timestamp" type="date" placeholder="选择日期">
                </el-date-picker>
                <el-date-picker @clear="timeClear('end')" class="form_codition" v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini" v-model="getRequestData[formOneValue.entityField]"
                                format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                </el-date-picker>
                <el-date-picker @clear="timeClear(formOneValue.entityField)" class="form_codition" v-else-if="formOneValue.fieldType == 'date'" size="mini" v-model="getRequestData[formOneValue.entityField]"
                                format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                </el-date-picker>
                <el-select filterable class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @change="selectChange" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                    <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                               :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                </el-select>
                <el-select filterable class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'select'" @change="selectChange" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                    <el-option v-for="matItem in formOneValue.formatterContent" :key="matItem.key" :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                               :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                </el-select>
                <el-cascader ref="cascader" :props="{ emitPath: false }" v-else-if="formOneValue.fieldType == 'city'" class="form_codition" :options="options" v-model="getRequestData[formOneValue.entityField]" clearable
                             filterable>
                </el-cascader>
                <el-tooltip v-else class="item" :disabled="getRequestData[formOneValue.entityField] == null || getRequestData[formOneValue.entityField] == '' ? true : false" effect="dark"
                            :content="getRequestData[formOneValue.entityField]" placement="bottom-start">
                    <el-input class="form_codition" clearable v-model.trim="getRequestData[formOneValue.entityField]" @keyup.enter.native="searchData" size="mini" :maxlength="$store.state.inputLength"></el-input>
                </el-tooltip>
            </el-form-item>
        </template>
        <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
            <slot name="buttonType"></slot>
        </el-form-item>
        <el-form-item v-if="showMx">
            <el-button type="primary" size="mini" @click="saveData">保存</el-button>
        </el-form-item>
        <!-- <el-form-item v-if="showMx">
            <span style="font-size: 20px;">预付金额: <span>{{ totalInfo.settleMoney }}</span></span> <span
                style="margin-left: 10px;font-size: 20px;">结算总金额: <span>{{ totalInfo.totalMoney }}</span></span>
        </el-form-item> -->
    </el-form>
</template>

<script>
import { regionData } from 'element-china-area-data'
export default {
    name: "vSearch",
    props: {
        searchList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        getRequestData: {
            type: Object,
            default: () => {
                return {};
            },
        },
        flagList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        showMx: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        //判断是否启用必填项
        ruleFlag: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        totalInfo: {
            type: Object,
            default: () => {
                return {
                    totalMoney: "",
                    settleMoney: "",
                };
            },
        },
    },
    data() {
        return {
            options: regionData,
        };
    },
    methods: {
        timeClear(val) {
            if (this.getRequestData[val] == null) {
                this.getRequestData[val] = "";
            }
        },
        flag(val) {
            var flags = false;
            this.flagList.forEach((item) => {
                if (val.entityField == item) {
                    flags = true;
                }
            });
            if (flags) {
                return true;
            } else {
                return false;
            }
        },
        searchData() {
            console.log(123123);

            //SEARCH
            this.$refs['SEARCH'].validate((valid) => {
                if (valid) {
                    this.$emit("searchData", this.getRequestData);
                } else {
                    this.$message.error("请输入必填项！")
                    return false;
                }
            });

        },
        openSearch(sId, index, type, sField) {
            this.$emit("openSearch", {
                sId: sId,
                index: index,
                type: type,
                sField: sField,
                field: sField,
            });
            const field = sField;
            this.$emit("openSearchs", sId, index, type, sField, field);
        },
        clear(val) {
            if (val) {
                var arr = val.split(",");
                arr.forEach((item) => {
                    this.$set(this.getRequestData, item, "");
                });
                //    this.$emit("searchData", this.getRequestData);
            }
        },
        selectChange() {
            // this.$emit("searchData", this.getRequestData);
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        saveData() {
            this.$emit("saveData");
        },
    },
};
</script>

<style></style>